export const EVENTS = {
  VIEW_STORE: "web_view_store",
  VIEW_PRODUCT: "web_view_product",
  SELECT_ADD_PRODUCT: "web_select_add_product",
  ERROR_CREATE_ORDER: "web_send_order_error",
  SELECT_ADD_PRODUCT_QUANTITY: "web_select_add_product_quantity",
  SELECT_SUBSTRACT_PRODUCT_QUANTITY: "web_select_substract_product_quantity",
  SELECT_VIEW_CART: "web_select_view_cart",
  SELECT_INPUT_NAME: "web_select_input_name",
  SELECT_INPUT_LAST_NAME: "web_select_input_last_name",
  SELECT_INPUT_PHONE: "web_select_input_phone",
  SELECT_SHIPPING_METHOD: "web_select_shipping_method",
  SELECT_STORE_PICKING_METHOD: "web_select_store_picking_method",
  SELECT_MAP_LOCATION: "web_select_map_location",
  SELECT_INPUT_DELIVERY_ADDRESS: "web_select_input_delivery_address",
  SELECT_INPUT_DELIVERY_ADDRESS_DETAIL:
    "web_select_input_delivery_address_details",
  SELECT_SEND_ORDER: "web_select_send_order",
  CLICK_REWARDS: "web_click_to_rewards",
  PAY_NOW: "view_pay_now",
  SELECT_PAY_NOW: "select_pay_now",
  SELECT_PAYMENT_UPON_DELIVERY: "select_payment_upon_delivery",
  SELECT_PAYMENT_PHONE_NUMBER: "select_payment_phone_number",
  SELECT_INPUT_NAME_PAYMENT: "select_input_name_payment",
  SELECT_INPUT_ADDRESS_PAYMENT: "select_input_address_payment",
  SELECT_INPUT_EMAIL_PAYMENT: "select_input_email_payment",
  SELECT_INPUT_ID_TYPE_PAYMENT: "select_input_id_type_payment",
  SELECT_INPUT_ID_NUMBER_PAYMENT: "select_input_id_number_payment",
  SELECT_INPUT_PREFIX_PHONE_PAYMENT: "select_input_prefix_phone_payment",
  SELECT_INPUT_PHONE_PAYMENT: "select_input_phone_payment",
  SELECT_PAY_WITH_CARD: "select_pay_with_card",
  SELECT_PAY_WITH_BANK_TRANSFER: "select_pay_with_bank_transfer",
  SELECT_PAY_WITH_BANK_NAME: "select_input_bank_name",
  SELECT_PAY_TRANSFER: "select_pay_transfer",
  SELECT_PAY_IN_VENUE: "select_pay_in_venue",
  SELECT_VENUE: "select_venue",
  SELECT_PAY_VENUE: "select_pay_venue",
  SYSTEM_LINK_PAYED: "system_link_payed",
  SYSTEM_LINK_PAYMENT_ERROR: "system_link_payment_error",
  SELECT_PROFILE: "web_select_profile",
  SELECT_COUNTRY_PHONE: "web_select_phone_country",
  SELECT_INPUT_PROFILE_PHONE: "web_select_input_profile_phone",
  SELECT_ACCEPT_TERMS: "web_select_accept_terms",
  SELECT_SMS_CONFIRM: "web_select_sms_confirm",
  SELECT_WA_CONFIRM: "web_select_wa_confirm",
  SELECT_HELP: "web_select_help",
  SELECT_INPUT_CODE: "web_select_input_code",
  SELECT_RESEND_CODE: "web_select_resend_code",
  SELECT_CONFIRM_CODE: "web_select_confirm_code",
  SELECT_INPUT_BUYER_NAME: "web_select_input_buyer_name",
  SELECT_BUYER_LAST_NAME: "web_select_input_buyer_last_name",
  SELECT_CONFIRM_NAME: "web_select_confirm_name",
  SELECT_LOGOUT: "web_select_logout",
  SELECT_MENU: "web_select_menu",
  SELECT_STORE_INFO: "web_select_header_contact_us",
  SELECT_SHARE_STORE: "web_select_share_store",
  SELECT_PURCHASE: "web_select_my_purchases",
  SELECT_VIEW_PROFILE: "web_select_view_profile",
  SELECT_PERSONAL_INFO: "web_select_personal_info",
  SELECT_MY_ADDRESSES: "web_select_my_addresses",
  SELECT_ADD_ADDRESS: "web_select_add_address",
  SELECT_DELETE_ADDRESS: "web_select_confirm_delete_address",
  SELECT_EDIT_ADDRESS: "web_select_edit_address",
  SAVE_PERSONAL_INFO: "web_select_save_personal_info",
  SAVE_NEW_ADDRESS: "web_select_save_new_address",
  SAVE_EDIT_ADDRESS: "web_select_save_edit_address",
  SELECT_TEMPLATES: "select_templates",
  SELECT_COLORS: "select_colors",
  SELECT_COVERS: "select_covers",
  SELECT_TEMPLATE: "select_template",
  APPLY_TEMPLATE: "select_personalization_apply_template",
  SELECT_COLOR_PALETTE: "select_color_palette",
  SELECT_ADD_COLORS: "select_add_colors",
  EDIT_FIRST_COLOR: "select_edit_first_color",
  EDIT_SECOND_COLOR: "select_edit_second_color",
  EDIT_THIRD_COLOR: "select_edit_third_color",
  APPLY_COLOR: "select_personalization_apply_color",
  SELECT_COVER: "select_cover",
  SELECT_ADD_COVER: "select_add_cover",
  APPLY_COVER: "select_appy_cover",
  TEMPLATE_EXPERT_WARNING: "system_templates_expert_warning",
  COLOR_EXPERT_WARNING: "system_colors_expert_warning",
  COVER_EXPERT_WARNING: "system_image_expert_warning",
  SELECT_FONTS: "select_fonts",
  APPLY_FONT: "select_personalization_apply_font",
  SELECT_CONTACT_VENDOR: "web_select_contact_vendor",
  SELECT_SUPPORT_REQUEST: "web_select_support_request",
  SELECT_FOOTER_SUPPORT: "web_select_footer_support",
  SELECT_VIDEO_BUYING_GUIDE: "web_select_video_buying_guide",
  SELECT_SEARCH_PRODUCT: "web_search_product",
  SELECT_FILTER_ORDER: "web_select_filter_order",
  SELECT_APPLY_FILTER: "web_select_apply_filters",
  SELECT_CLEAN_FILTER: "web_select_clean_filters",
  SELECT_FILTER_PRODUCTS: "web_select_filter_products",
  SELECT_FILTER_SERVICES: "web_select_filter_services",
  FONT_EXPERT_WARNING: "system_font_expert_warning",
  HEADER_SELECT_SERVICES: "web_select_services",
  HEADER_SELECT_PROFILE: "web_select_profile",
  HEADER_SELECT_LOGIN: "web_select_login",
  HEADER_SELECT_MENU: "web_select_menu",
  SELECT_GO_TO_CART_ALERT: "web_select_go_to_cart_alert",
  FOOTER_SELECT_LINK: "select_link",
  SELECT_BUTTON: "select_button",
};

export const keyViewStore = "send_event_web_view_store";
